<script>
// Mixins
import styles from '../mixins/styles.js';

// Types
import { 
    tableCellVariants,
    tableCellAlign
} from '../types/TableCell.types';

// Utils
import { eligibleProp, EmptyOrEligibleProp } from '../utils/props-utils';

export default {
    name: 'TableCell',
    mixins: [styles],
    props: {
        variant: {
            type: String,
            default: '',
            validator: eligibleProp(tableCellVariants)
        },
        textAlign: {
            type: String,
            default: '',
            validator: EmptyOrEligibleProp(tableCellAlign)
        }
    },
    computed: {
        typographyClasses: function () {
            return [
                this.textAlign && this.cssClasses[`pcc__tableCell_textAlign_${this.textAlign}`]
            ];
        }
    },
    render: function (createTypo) {
        return createTypo(this.variant, { class: this.typographyClasses }, this.$slots.default);
    }
}
</script>
